import React from "react";

const KeyCode = {
  Enter: 13,
};

/**
 * Hook to set up an event listener within a form so that Ctrl+Enter (Windows
 * and Linux) or Command+Enter (Mac) will submit it when any child element has
 * focus.
 *
 * @param {import("react").RefObject<HTMLFormElement>} formRef
 */
export function useCommandEnterFormSubmission(formRef) {
  React.useEffect(() => {
    const form = formRef.current;

    function listener(event) {
      if (event.keyCode === KeyCode.Enter && (event.metaKey || event.ctrlKey)) {
        const submitButton = form.querySelector('[type="submit"]');
        if (submitButton && submitButton.disabled) return;

        form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
      }
    }

    if (form) {
      form.addEventListener("keydown", listener, true);

      return () => form.removeEventListener("keydown", listener, true);
    }
  }, [formRef]);
}
